/**
 * Set when a guest joined through quick join (environment.features.quickGuestJoin)
 * and was named guest-MMDD-HHmmss instead of typing a name. The upload dialog
 * asks for a real name while it is set; it is removed once the name is saved.
 */
export const GUEST_AUTO_NAME_KEY = 'guestAutoName';

/**
 * Whether a name is one quickGuestName() generated (guest-MMDD-HHmmss) rather
 * than one the guest typed. The flag above is only worth setting for these: a
 * rejoining guest reaches the same code path carrying the real name they gave
 * the first time, and must not be asked for it again.
 */
export function isGuestAutoName(name: string | null | undefined): boolean {
  return !!name && /^guest-\d{4}-\d{6}$/.test(name);
}
